/** True while the deadline to request a reschedule has not passed. */
export const isRescheduleWindowOpen = (rescheduleUntil: string | null, now: Date = new Date()): boolean => {
  if (!rescheduleUntil) {
    return false;
  }

  const deadline = new Date(rescheduleUntil).getTime();

  return !Number.isNaN(deadline) && deadline > now.getTime();
};
